import api from "./api";

export default {
  index(model, pagination = false, page = 1, limit = 100, search=false){
    return api.get(`${model}`, {
      params:{pagination:pagination,page:page, limit: limit, search}});
  },
  paginate(model, page = 1, limit = 100, search='', pagination = true){
    return api.get(`${model}`, {
      params:{pagination:pagination,page:page, limit: limit, search}});
  },
  create(model, data){
    return api.post(`${model}`, data);
  },
  update(model, id,data){
    return api.patch(`${model}/${id}`, data);
  },

  show(model, id, page = 1, limit = 8){
    return api.get(`${model}/${id}`, {
      params:{page:page, limit: limit}
    });
  },

  
  destroy(model,id){
    return api.delete(`${model}/${id}`);
  },
  postWithConfig(model, data, config){
    return api.post(`${model}`, data, config);
  },

  addedFrom(from){
    return api.get(`users/from/${from}`);
  },
  campaigns(campaign){
    return api.get(`users/campaigns/${campaign}`);
  },
  campaignsFilter(filter){
    return api.post('users/campaigns/filter', filter);
  },
  closeChatMode(data){
    return api.post(`whatsapp/active_flow`, data);
  },

  // [matrah] legacy: `whatsapp/toggle_flow` is now Laravel-only (X-Internal-Secret) → the dashboard got a 401
  // and was logged out. The dashboard uses its own JWT route instead (id = contact User _id).
  // toggleChatMode(data){
  //   return api.post(`whatsapp/toggle_flow`, data);
  // },
  toggleChatMode(data){
    return api.post(`conversations/${encodeURIComponent(data.id || data.phone_number)}/toggle-staff-mode`);
  },

  // [matrah] staff ends "talk to staff" mode: flag off + closing message + main menu to the donor
  endStaffMode(id){
    return api.post(`conversations/${encodeURIComponent(id)}/end-staff-mode`);
  },

  hideUnhideFrom(action, from){
    return api.get(`users/${action}/${from}`);
  },

  // [matrah] Meta message-template management (server proxies to Graph API).
  createTemplate(data){
    return api.post('templates', data);
  },
  deleteTemplate(name){
    return api.delete(`templates/${encodeURIComponent(name)}`);
  },

};
